/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 23-10-2020.
 */
import React from 'react'
import Spinner from './Spinner'

type Props = {
  children?: React.ReactNode | null
  fullHeight?: boolean
}

export const SpinnerFullHeight: React.FC<Props> = ({ fullHeight = false, children = null }) => {
  const addHeight = fullHeight === true ? 'h-100' : ''
  const cla = 'container-fluid px-0 no-blurry ' + addHeight
  return (
    <div className={cla}>
      <div className="row h-100" style={{}}>
        <div className="col-12 h-50 d-flex justify-content-center align-items-center" style={{}}>
          <div className="d-flex align-items-center flex-column">
            <Spinner style={{ marginBottom: 30 }} size={10}></Spinner>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
